import { render, staticRenderFns } from "./orderInquery.vue?vue&type=template&id=4c88df16&"
import script from "./orderInquery.vue?vue&type=script&lang=js&"
export * from "./orderInquery.vue?vue&type=script&lang=js&"
import style0 from "./orderInquery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "orderInquery.vue"
export default component.exports